<template>
    <v-container fluid class="pr-0 pl-0">
        <logo @cambiaAnio="listarActividadesCompesacion" v-sticky="{ zIndex: 4, stickyTop: 65}" />
        <navParameters :navParams="navParams"/>
        <v-row>
            <v-col cols="12">
                <tituloPrincipal titulo="Actividades de Compensación"/>
            </v-col>
        </v-row>
        <v-row>
            <v-col cols="6" md="3" align-self="center">
                <div class="d-flex">
                    <agregarActividad 
                        @reload="listarActividadesCompesacion" 
                        @agregarActividad="agregarActividad" 
                        v-bind:instalacion="instalacion"
                        v-if="rolUsuario != 'CEO' && rolUsuario != 'GERENTE' && rolUsuario != 'SUPERVISOR'"
                    />
                    <div class="pl-3">
                        <RepositorioEvidencias 
                            titulo="Repositorio de Evidencias" 
                            tooltipText="Repositorio de Evidencias" 
                            icon="mdi mdi-source-repository" :tipo="3"
                        />
                    </div>
                </div>
            </v-col>
            <v-col cols="6" md="2" offset-md="7">
                <v-text-field
                    prepend-inner-icon="mdi-magnify"
                    label="Buscar"
                    v-model="search"
                ></v-text-field>
            </v-col>
        </v-row>
        <v-card>
            <tituloSimple titulo="Actividades de Compensación"/>
            <v-card-text>
                <ActividadesTabla :search="search" v-bind:headers="headers" v-bind:actividades="data" @reload="listarActividadesCompesacion"/>
            </v-card-text>
        </v-card>
    </v-container>
</template>
<script>

import VueSticky from 'vue-sticky'
import Logo from '@/components/utils/CompanyComponent'
import TituloPrincipal from '@/components/utils/TituloPrincipalComponent'
import TituloSimple from '@/components/utils/TituloSimpleComponent'
import RepositorioEvidencias from "@/components/documentos/RepositorioEvidencias";
import ActividadesTabla from "@/components/parametros/ActividadCompesacion/ActividadesCompeTablaComponent"
import AgregarActividad from "@/components/parametros/ActividadCompesacion/AgregarActvidadCompeComponent"
import NavParameters from '@/components/utils/NavParameterComponent'
import axios from "@/axios.js";

export default {

    created() {
        axios.defaults.headers.common['Authorization'] = "Bearer " + this.$store.getters.token;
    },  
    directives: {
        'sticky': VueSticky,
    },
    props: [
        'navParams'
    ],
    computed: {
        indicadorActual() {
            return this.$store.getters.indicadorActual;
        },
        instalacion() {
            return this.$store.getters.sucursal;
        },
        rolUsuario(){
            return this.$store.getters.usuario.rol;
        },
        anioConsulta() {
            return this. $store.getters.anioConsulta;
        },
        fromRepository() {
            return this.selectEvi.length > 0
        }
    },
    components: {
        RepositorioEvidencias,
        ActividadesTabla,
        AgregarActividad,
        NavParameters,
        TituloSimple,
        TituloPrincipal,
        Logo
    },
    data: () => ({
        search: null,
        data: [],
        headers: [
            {
                text: "Acciones",
                value: "action",
                align: "center",
            },
            {
                text: "Actividad",
                value: "actividad",
                align: "start",
            },
            {
                text: "Fecha de la Actividad",
                value: "fechaActividad",
                align: "center",
            },
            {
                text: "Logros alcanzados",
                value: "logros",
                align: "start",
            },
            {
                text: "Beneficiarios",
                value: "beneficiarios",
                align: "center",
            },
            {
                text: "Evidencia",
                value: "evidencia",
                align: "center",
            },
        ]
    }),
    mounted () {
        this.listarActividadesCompesacion();
    },
    methods: {
        agregarActividad(actividad) {
            this.data.push(actividad);
        },
        listarActividadesCompesacion(){
            let idInstalacion = this.instalacion.id;
            let year = this.anioConsulta;
            axios.get("/actividadCompesacion/listarActvidadesCompesacion/"+idInstalacion,{params:{year: year}}).then(response => {
                this.data = response.data.actividades;
                this.items = response.data.years;
                this.loadingModal(false);
            }).catch(error => {
              if (error.request && error.request.status === 401) {
                this.$store.commit('showSessionDialog', true);
              } else {
                console.log(error);
                this.loadingModal(false);
              }
            })
        },
        loadingModal(modal) {                        
            this.$store.dispatch('loadingPage', modal);
        },   
    }
}
</script>